"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_MENU_WIDTH = exports.CONSTRAIN = exports.ALIGNMENTS = void 0;
var ALIGNMENTS = {
  left: {
    attachmentHoriz: 'left',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'left',
    targetAttachmentVert: 'bottom'
  },
  middle: {
    attachmentHoriz: 'center',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'center',
    targetAttachmentVert: 'bottom'
  },
  right: {
    attachmentHoriz: 'right',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'right',
    targetAttachmentVert: 'bottom'
  }
};
exports.ALIGNMENTS = ALIGNMENTS;
var CONSTRAIN = {
  both: [{
    attachment: 'together none',
    pin: ['left', 'right'],
    to: 'window'
  }],
  none: [],
  horizontal: [{
    attachment: 'none',
    pin: ['left', 'right'],
    to: 'window'
  }],
  vertical: [{
    attachment: 'together none',
    to: 'window'
  }]
};
exports.CONSTRAIN = CONSTRAIN;
var MIN_MENU_WIDTH = 144;
exports.MIN_MENU_WIDTH = MIN_MENU_WIDTH;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/constants/Tether.js
// module id = 373
// module chunks = 209 210 211 212